import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import "./BudgetPicker.scss"
import BudgetIcon from "../../components/BudgetIcon"

interface Props {
    value: number | null
    suggestedValue?: number | null
    onChange: (budget_id: number | null) => void
    budgets: Budget[]
    disabled?: boolean
}
const PICKER_TRANSITION_MS = 200

const BudgetPicker = (props: Props) => {
    const selectRef = useRef<HTMLDivElement>(null)
    const  { value, onChange, suggestedValue, disabled } = props
    // Le budget Transfert en dernier, à part : il veut dire « pas de budget ».
    const budgets = useMemo(() => [...props.budgets.filter(({transfer}) => !transfer), ...props.budgets.filter(({transfer}) => transfer)], [props.budgets])
    const [editMode, setEditMode] = useState(false)
    const [editModeVisible, setEditModeVisible] = useState(false)

    const budgetById = useCallback((budget_id: number | null | undefined) => budgets.find(({id}) => budget_id === id), [budgets])

    const [budget, setBudget] = useState(undefined as Budget | undefined)
    const [suggestedBudget, setSuggestedBudget] = useState(undefined as Budget | undefined)
    const [currentBudget, setCurrentBudget] = useState(undefined as Budget | undefined)


    useEffect(() => setBudget(budgetById(value)), [value, budgets, budgetById])
    useEffect(() => setSuggestedBudget(budgetById(suggestedValue)), [suggestedValue, budgets, budgetById])
    useEffect(() => setCurrentBudget(budget), [budget])

    const pick = (budgetId: number | null) => {
        setBudget(budgetById(value))
        dismissPicker()
        onChange(budgetId)
    }

    const handleClickOutside = (e: any) => {
        if(!(selectRef?.current && selectRef?.current.contains(e.target))) {
            dismissPicker()  
        }
    }

    const dismissPicker = () => {
        setEditModeVisible(false)
        setTimeout(() => {
            setEditMode(false)
        }, PICKER_TRANSITION_MS)   
    }
    const showPicker = () => {
        setEditMode(true)
        setTimeout(() => {
            setEditModeVisible(true)
        }, 0)  
    }

    useEffect(() => {
        if(editMode) {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [editMode])

    const handleClick = (e:  React.MouseEvent<HTMLElement>) => {
        if(disabled) {
            return
        }
        showPicker()
    }

        
    return <div className={`budget-picker ${disabled ? 'disabled' : ''}`}>
        { budget && <button className={`selected-budget tl-badge ${budget.transfer ? 'transfer' : 'tl-badge-cat'}`} onClick={handleClick}>
            <BudgetIcon budget={budget}/>
            <span className="budget-name">{budget.name}</span>
        </button>}
        { !budget && suggestedBudget && <button
            className="selected-budget tl-badge suggested"
            title="Suggestion : cliquer pour valider"
            onClick={() => pick(suggestedBudget.id)}>
            <BudgetIcon budget={suggestedBudget}/>
            <span className="budget-name">{suggestedBudget.name} ?</span>
        </button>}
        { !budget && !suggestedBudget && <button className="selected-budget tl-badge tl-badge-todo" onClick={handleClick}>
            À classer
        </button>}

        { editMode && <div className="cache"></div>}
        { editMode && <div
            className={`select ${editModeVisible ? 'visible' : ''}`}
            ref={selectRef}
            style={{backgroundColor: currentBudget?.color || '#ccc'}}
            >
            { budgets.map(budgetItem =>
                
                <div className={`option ${budgetItem.id === value ? 'selected' : ''} ${budgetItem.transfer ? 'transfer' : ''}`}
                    key={budgetItem.id}
                    onClick={() => pick(budgetItem.id)}
                    onMouseEnter={() => setCurrentBudget(budgetItem)}
                    onMouseLeave={() => setCurrentBudget(budget)}
                    >
                        <BudgetIcon budget={budgetItem} color='#fff'/>
                        </div>
            )}
            { budget && <div className="option unknown" onClick={() => pick(null)}>
                <BudgetIcon budget={undefined} color='#fff'/>
            </div> }
            { currentBudget && <div className='current-option'>
                <BudgetIcon budget={currentBudget} color='#fff'/>
                <div className='budget-name'>{currentBudget.name}</div>
            </div> }

        </div>}
    </div>
}

export default BudgetPicker

